module.exports = __webpack_public_path__ + "9521c88a236b84ff8976ef137039e53c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jewelry-photo/img/summary-jewelry-placeholder-external@2x.png
// module id = 777
// module chunks = 0